import { render, staticRenderFns } from "./ExpressOrderShowUser.vue?vue&type=template&id=71e8f6bb&scoped=true"
import script from "./ExpressOrderShowUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderShowUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e8f6bb",
  null
  
)

export default component.exports